import Vue from 'vue'
import Router from 'vue-router'
const Home = () => import('@/views/home')
// 关于迪哲
const About = () => import('@/views/about')
const AboutDizal = () => import('@/views/about/AboutDizal')
const ManagementTeam = () => import('@/views/about/ManagementTeam')
const Board = () => import('@/views/about/Board')
const AboutDeclaration = () => import('@/views/about/AboutDeclaration.vue')

// 创新
const Innovation = () => import('@/views/innovation')
const PipelineStrategy = () => import('@/views/innovation/PipelineStrategy')
const Science = () => import('@/views/innovation/Science')
const ExpandedAccess = () => import('@/views/innovation/ExpandedAccess')

// 新闻
const News = () => import('@/views/news')
const NewsList = () => import('@/views/news/List.vue')
const NewsDetail = () => import('@/views/news/Detail.vue')
const PTCLDetail = () => import('@/views/news/PTCLDetail.vue')

// 投资者关系
const Investors = () => import('@/views/ir')
const Annoucement = () => import('@/views/ir/Annoucement')
// const Stock = () => import('@/views/ir/Stock')
const IRContact = () => import('@/views/ir/IRContact')
// const Governance = () => import('@/views/ir/Governance')

// 招聘
const Careers = () => import('@/views/careers')
// const CultrueBenefit = () => import('@/views/careers/CultrueBenefit.vue')
// const Opportunity = () => import('@/views/careers/Opportunity.vue')
// const Recruitment = () => import('@/views/careers/Recruitment.vue')
// const Campus = () => import('@/views/careers/Campus.vue')
// const JobDetail = () => import('@/views/careers/JobDetail.vue')
// const CampusDetail = () => import('@/views/careers/CampusDetail.vue')

// 联系方式
const Contact = () => import('@/views/contact')
const LocationMap = () => import('@/views/contact/LocationMap.vue')

Vue.use(Router)

export default new Router({
  mode: 'history',
  // base: '/dizalpharma/',
  routes: [
    // 主页
    {
      path: '/',
      name: 'homeLink',
      component: Home,
      meta: {
        title: 'company_name'
      }
    },
    // 关于
    {
      path: '/about',
      name: 'aboutLink',
      component: About,
      redirect: '/about',
      meta: {
        title: 'nav.about'
      },
      children: [
        // 关于迪哲
        {
          path: '/about',
          name: 'aboutDizalLink',
          component: AboutDizal,
          meta: {
            title: 'about.about_dizal'
          }
        },
        // 管理团队
        {
          path: '/about/management-team',
          name: 'managementTeamLink',
          component: ManagementTeam,
          meta: {
            title: 'management'
          }
        },
        // 董事会
        {
          path: '/about/board',
          name: 'boardLink',
          component: Board,
          meta: {
            title: 'board'
          }
        }
      ]
    },
    // 声明
    {
      path: '/about/declaration',
      name: 'aboutDeclarationLink',
      component: AboutDeclaration,
      meta: {
        title: 'about.about_dizal'
      }
    },
    // 招聘
    {
      path: '/careers',
      name: 'careersLink',
      component: Careers,
      meta: {
        title: 'nav.careers'
      },
      children: [
        // 企业文化和公司福利
        // {
        //   path: '/careers',
        //   name: 'cultrueBenefitLink',
        //   component: CultrueBenefit,
        //   meta: {
        //     title: 'culture.name'
        //   }
        // }
        // 机遇、职位
        // {
        //   path: '/careers/opportunity',
        //   name: 'opportunityLink',
        //   component: Opportunity,
        //   meta: {
        //     title: 'jobs'
        //   }
        // },
        // {
        //   path: '/careers/recruitment',
        //   name: 'recruitment',
        //   component: Recruitment,
        //   meta: {
        //     title: ''
        //   }
        // },
        // {
        //   path: '/careers/campus',
        //   name: 'campusLink',
        //   component: Campus,
        //   meta: {
        //     title: 'campus'
        //   },
        //   beforeEnter: () => {
        //     window.location.href = 'https://app.mokahr.com/campus-recruitment/dizalpharmaceutical/72241'
        //   }
        // }
        /*  职位详情
        {
          path: '/careers/opportunity/detail',
          name: 'jobDetailLink',
          component: JobDetail,
          meta: {
            title: 'nav.detail'
          },
        },
         //   职位详情
         {
          path: '/careers/campus/detail',
          name: 'campusDetailLink',
          component: CampusDetail,
          meta: {
            title: 'nav.detail'
          },
        }*/
      ]
    },
    // 联系
    {
      path: '/contact',
      name: 'contactLink',
      component: Contact,
      meta: {
        title: 'contact_us'
      }
    },
    {
      path: '/contact/map',
      name: 'locationMapLink',
      component: LocationMap,
      meta: {
        title: 'contact_us'
      }
    },
    // 新闻
    {
      path: '/news',
      name: 'newsLink',
      component: News,
      meta: {
        title: 'nav.news'
      },
      redirect: '/news',
      children: [
        // 新闻列表
        {
          path: '/news',
          name: 'newsListLink',
          component: NewsList,
          meta: {
            title: 'news_list'
          }
        },
        // 新闻详情
        {
          path: '/news/detail',
          name: 'newsDetailLink',
          component: NewsDetail,
          meta: {
            title: 'news_detail'
          }
        },
        // PTCL详情
        {
          path: '/news/ptcl',
          name: 'ptclDetailLink',
          component: PTCLDetail,
          meta: {
            title: 'ptcl_detail'
          }
        }
      ]
    },
    // 创新研发
    {
      path: '/innovation',
      name: 'innovationLink',
      component: Innovation,
      redirect: '/innovation/P&S',
      meta: {
        title: 'nav.innovation'
      },
      children: [
        //   研发产品 和 发展策略
        {
          path: '/innovation/P&S',
          name: 'pipelineStrategyLink',
          component: PipelineStrategy,
          meta: {
            title: 'nav.pipelineStrategy'
          }
        },
        // 创新
        {
          path: '/innovation/science',
          name: 'scienceLink',
          component: Science,
          meta: {
            title: 'nav.science'
          }
        },
        // 临床实验
        {
          path: '/innovation/expanded-access',
          name: 'expandedAccessLink',
          component: ExpandedAccess,
          meta: {
            title: 'nav.expandedAccess'
          }
        }
      ]
    },
    /* 投资者关系*/
    {
      path: '/ir',
      name: 'irLink',
      component: Investors,
      redirect: '/ir/annoucement',
      meta: {
        title: 'nav.ir'
      },
      children: [
        //  公告
        {
          path: '/ir/annoucement',
          name: 'annoucementLink',
          component: Annoucement,
          meta: {
            title: 'nav.annoucement'
          }
        },
        // IR联系方式
        {
          path: '/ir/contact',
          name: 'irContactLink',
          component: IRContact,
          meta: {
            title: 'nav.irContact'
          }
        }
        /* 公司治理
         {
          path: '/ir/governance',
          name: 'governanceLink',
          component: Governance,
          meta: {
            title: 'nav.governance'
          }
        }*/
      ]
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js